// What is still outstanding before a declaration file may be generated (PR-C). One function, used by both the
// checklist (to highlight what is missing) and the page (to grey out Generate / Submit), so the two cannot disagree.
import type { V2Decisions, PrecheckResult, ReviewItem, PrecheckCheck } from '../hooks/useECustoms'

export interface MissingItem { id: string; label: string }

export interface ChecklistStatus {
  missing: MissingItem[]        // decisions still to be made
  unticked: ReviewItem[]        // review items not yet ticked (or whose value changed since they were ticked)
  reds: PrecheckCheck[]         // blocking automatic checks
  yellows: PrecheckCheck[]
  blocker: string | null        // the generator refused to build the file at all (shown inside the checklist)
  remaining: number
  complete: boolean
}

export function isRoadMode(mode: string | null | undefined): boolean {
  const m = (mode || '').toLowerCase()
  return m === 'truck' || m === 'road'
}

export function checklistStatus(d: V2Decisions, pre: PrecheckResult | null, ticks: Record<string, string>, transportMode: string | null | undefined): ChecklistStatus {
  const missing: MissingItem[] = []
  if (!d.declType) missing.push({ id: 'decl_type', label: 'Declaration Type' })
  if (!d.declarantRep) missing.push({ id: 'rep', label: 'Declarant Representation' })
  if (!d.pvaMode) missing.push({ id: 'pva', label: 'VAT treatment (PVA / Non-PVA)' })
  if (!d.danMode) missing.push({ id: 'dan', label: 'Duty & VAT payment (DAN)' })
  if (!d.loadType) missing.push({ id: 'load', label: 'Load type' })
  if (!d.arrivalId.trim() || (pre?.missing || []).some(m => m.startsWith('Arrival Transport ID'))) missing.push({ id: 'arrival', label: 'Arrival Transport ID' })
  if (isRoadMode(transportMode) && !d.transitMrn.trim()) missing.push({ id: 'mrn', label: 'Transit MRN (T1)' })

  const review = pre?.review || []
  const unticked = review.filter(r => !r.value || ticks[r.id] !== r.value)
  const reds = (pre?.checks || []).filter(c => c.level === 'red')
  const yellows = (pre?.checks || []).filter(c => c.level === 'yellow')
  const blocker = pre?.blocker ?? null
  // Until the dry run has answered we cannot say the review items are complete.
  const waiting = !pre
  const remaining = missing.length + unticked.length + reds.length + (blocker ? 1 : 0) + (waiting ? 1 : 0)
  return { missing, unticked, reds, yellows, blocker, remaining, complete: remaining === 0 }
}
